import axios from '@/plugins/axios'
import { MessageBox, Message } from 'element-ui'

export default {
  namespaced: true,

  state: {
    loading: false,
    labels: [],
    users: [],
    allLabels: [],
    allArtists: [],
    dialog_form: false,
    dialog_deposit: false,
    filter_dialog: false,
    label: {
      id: null,
      name: '',
      user_type: null,
      artist: null,
      label: null
    },
    filters: {
      name: ''
    },
    page: 1,
    page_size: 10
  },

  getters: {
    getActiveLabel(state) {
      return labelId => {
        return state.labels.data.find(label => label.id === labelId)
      }
    }
  },

  mutations: {
    setLabels(state, payload) {
      state.labels = payload
    },
    setLabel(state, payload) {
      state.label.id = payload.id
      state.label.name = payload.name
      state.label.user_type = payload.user_type
      state.label.artist = payload.artist
      state.label.label = payload.label
    },
    setLabelForm(state, status) {
      state.dialog_form = status
      state.label.id = null
      state.label.name = ''
    },
    setLabelDeposit(state, status) {
      state.dialog_deposit = status
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setUsers(state, payload) {
      state.users = payload
    },
    setAllLabels(state, payload) {
      state.allLabels = payload
    },
    setAllArtists(state, payload) {
      state.allArtists = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setFilterDialog(state, status) {
      state.filter_dialog = status
    }
  },

  actions: {
    readLabels({ commit, state, rootState }) {
      return new Promise((res, rej) => {
        commit('setLoading', true)
        const filterToQuery = Object.keys(state.filters)
          .map(filter => filter + '=' + state.filters[filter])
          .join('&')
        axios.api
          .get(`vc/label/get?page=${state.page}&perPage=${state.page_size}&${filterToQuery}`)
          .then(r => {
            r.data.data.map(s => {
              s.balance = s.balance/10
              if(s.vc_campaign_track.length !== 0){
                s.vc_campaign_track.map(d => {
                  d.balance = d.balance/10
                })
              }
            })
            commit('setLabels', r.data)
            commit('setLoading', false)
            res(r.data.data)

            if(rootState.vcTrack.active_label !== null){
              let label = r.data.data.filter(obj => {
                return obj.id === rootState.vcTrack.active_label
              })

              this.commit('vcTrack/setTracks', label[0].vc_campaign_track)
            }
          })
          .catch(e => {
            commit('setLoading', false)
            rej(e)
          })
      })
    },

    createLabel({ dispatch, commit, state }) {
      axios.api
        .post('vc/label/create', {
          name: state.label.name,
          user_type: state.label.user_type,
          artist: state.label.artist,
          label: state.label.label
        })
        .then(() => {
          var label = {
            id: null,
            name: '',
            user_type: null,
            artist: null,
            label: null
          }
          dispatch('readLabels')
          dispatch('getLabel')
          dispatch('getArtist')
          commit('setLabelForm', false)
          commit('setLabel', label)
        })
    },

    depositLabel({ state, commit, dispatch }, deposit) {
      MessageBox.confirm(
        `You will deposit $${deposit} to ${state.label.name} label. Continue?`,
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          deposit = deposit * 10
          axios.api
            .post(`vc/label/${state.label.id}/deposit/${deposit}`)
            .then(() => {
              commit('setLabelDeposit', false)
              dispatch('readLabels')
            })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: 'Deposit cancelled'
          })
        })
    },

    getLabel({ commit }) {
      commit('setLoading', true)
      axios.api
        .get('vc/label/label')
        .then(r => {
          commit('setAllLabels', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    getArtist({ commit }) {
      commit('setLoading', true)
      axios.api
        .get('vc/label/artist')
        .then(r => {
          commit('setAllArtists', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  }
}
